/* eslint-disable @typescript-eslint/no-unused-vars */
import type { Maybe } from '@backmarket/utils/types/Maybe'
import { z } from 'zod/mini'

import type { Equal, ExpectTrue } from '../types/validation'

/* Typescript exports */
export type LinkTarget = '_blank' | '_self'

export type ContentLink = {
  href: string
  target?: Maybe<LinkTarget>
  rel?: Maybe<string>
}

/* Schemas */
export const LinkTargetSchema = z.enum(['_blank', '_self'])

export const ContentLinkSchema = z.object({
  href: z.string(),
  target: z.nullish(LinkTargetSchema),
  rel: z.nullish(z.string()),
})

export const ContentLinkWithTargetBlankSchema = z.object({
  href: z.string(),
  target: z.nullish(LinkTargetSchema),
  rel: z.nullish(z.string()),
  targetBlank: z.nullish(z.boolean()),
})

/* Schemas validation */
type TestContentLink = ExpectTrue<
  Equal<ContentLink, z.infer<typeof ContentLinkSchema>>
>
